import { z } from 'zod';
import { Auth0UserSchema } from '../../logStreamEvents/base/base.js';
export const GetSmsUserParamsSchema = z.object({
    userId: z.string(),
});
export const GetSmsUserHeadersSchema = z.object({
    requestActor: z.string().optional(),
});
export const GetSmsUserRequestSchema = GetSmsUserParamsSchema.merge(GetSmsUserHeadersSchema);
export const GetSmsUserResponseSchema = z.object({
    hasSmsConnection: z.boolean(),
    user: Auth0UserSchema.optional(),
});
export const GetSmsUserApiSchema = {
    headers: GetSmsUserHeadersSchema,
    response: GetSmsUserResponseSchema,
    params: GetSmsUserParamsSchema,
};
